import type {DominioTiempo, TSite} from "services-comun-meteored/modules/portal/tiempo";


export abstract class Configuracion<T> {
    /* INSTANCE */
    protected constructor(public readonly modulo: string, protected readonly site: TSite, protected readonly data: T) {
    }

    public toJSON(): T {
        return this.data;
    }
}

export abstract class ConfiguracionBuilder<T> {
    /* INSTANCE */
    private readonly portales: Record<TSite, Configuracion<T>>;

    protected constructor() {
        this.portales = {
            ar: this.build("ar"),
            at: this.build("at"),
            bo: this.build("bo"),
            br: this.build("br"),
            ca: this.build("ca"),
            cl: this.build("cl"),
            cr: this.build("cr"),
            de: this.build("de"),
            do: this.build("do"),
            ec: this.build("ec"),
            en: this.build("en"),
            es: this.build("es"),
            eu: this.build("eu"),
            fr: this.build("fr"),
            hn: this.build("hn"),
            it: this.build("it"),
            mx: this.build("mx"),
            nl: this.build("nl"),
            pa: this.build("pa"),
            pe: this.build("pe"),
            pt: this.build("pt"),
            py: this.build("py"),
            ru: this.build("ru"),
            uy: this.build("uy"),
            ve: this.build("ve"),
        };
    }

    public getDominio(dominio: DominioTiempo): Configuracion<T> {
        return this.portales[dominio.id];
    }

    public getSite(site: TSite): Configuracion<T> {
        return this.portales[site];
    }

    protected abstract build(site: TSite): Configuracion<T>;
}
